export default "__VITE_ASSET__59rg72OB__"